export default __webpack_public_path__ + "static/ok-sign-789c28ad4de6f10d38b8fd2b190b4ee2.png";